import Layout from '../../config/Layout';
import Colors from '../../config/Colors';

const styles = {
    container: {
        flex: 1,
        flexDirection: 'column'
    },
    contentLine: {
        height: 45,
        paddingLeft: Layout.gutterMedium,
        justifyContent: 'center'
    },
    selectedLine: {
        height: 45,
        paddingLeft: Layout.gutterMedium,
        backgroundColor: Colors.lightBlue,
        justifyContent: 'center'
    },
    lastContentLine: {
        height: 45,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: Layout.gutterMedium,
        borderColor: Colors.border,
        borderTopWidth: 1
    },
    text: {
        color: Colors.black,
        justifyContent: 'flex-start',
        fontSize: 18
    },
    icon: {
        justifyContent: 'flex-end'
    }
};

export default styles;
